export default "__VITE_ASSET__CGhCrhhK__"